export default "__VITE_ASSET__Chl67bQr__"